module.exports = __webpack_public_path__ + "img/TAC6000_1-1.2c70844d.png";